import { all } from 'redux-saga/effects'
import watchSessionsSagas from './sessions'
import watchAnalyticsSagas from './analytics'

import interviewRequestsSagas from '../../InterviewRequests/redux/sagas'
import profileSagas from '../../Profile/sagas'
import dashboardSagas from '../../Dashboard/redux/sagas'
import onboardingSagas from '../../Onboarding/redux/sagas'

export default function* rootSaga() {
  yield all([
    watchAnalyticsSagas(),
    watchSessionsSagas(),

    ...interviewRequestsSagas(),
    ...profileSagas(),
    ...dashboardSagas(),
    ...onboardingSagas(),
  ])
}
